import moment from "moment";
import "moment/locale/fa";
import { useEffect } from "react";
import { connect } from "react-redux";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import "./App.css";
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import PermissionRoute from "./Components/PermissionRoute/PermissionRoute";
import { smsCampaignPermissions } from "./Util/smsCampaignPermissions";
import Layout from "./Containers/Layout/Layout";
import AutoNoteManager from "./Containers/Pages/AutoNoteManager/AutoNoteManager";
import CopyRoadmap from "./Containers/Pages/CopyRoadmap/CopyRoadmap";
import SwitchUsername from "./Containers/Pages/SwitchUsername/SwitchUsername";
import ExternalDiscount from "./Containers/Pages/ExternalDiscount/ExternalDiscount";
import Flags from "./Containers/Pages/Flags/Flags";
import Home from "./Containers/Pages/Home/Home";
import Login from "./Containers/Pages/Login/Login";
import NotFound from "./Containers/Pages/NotFound/NotFound";
import PaymentSkip from "./Containers/Pages/Payment/PaymentSkip";
import PermissionAccess from "./Containers/Pages/PermissionAccess/PermissionAccess";
import PermissionDenied from "./Containers/Pages/PermissionDenied/PermissionDenied";
import Admins from "./Containers/Pages/Permissions/Admins/Admins";
import Permissions from "./Containers/Pages/Permissions/Permissions";
import Roles from "./Containers/Pages/Permissions/Roles/Roles";
import DiscountCode from "./Containers/Pages/Product/DiscountCode/DiscountCode";
import Price from "./Containers/Pages/Product/Price/Price";
import Product from "./Containers/Pages/Product/Product";
import ConsultingRequestsReport from "./Containers/Pages/Reports/ConsultingRequestsReport/ConsultingRequestsReport";
import OperatorsReport from "./Containers/Pages/Reports/OperatorsReport/OperatorsReport";
import QuestionsReport from "./Containers/Pages/Reports/QuestionsReport/QuestionsReport";
import Reports from "./Containers/Pages/Reports/Reports";
import UsersReport from "./Containers/Pages/Reports/UsersReport/UsersReport";
import VoteReport from "./Containers/Pages/Reports/VoteReport/VoteReport";
import Roadmaps from "./Containers/Pages/Roadmaps/Roadmaps";
import RoadmapTypes from "./Containers/Pages/RoadmapTypes/RoadmapTypes";
import Skills from "./Containers/Pages/Skills/Skills";
import Type from "./Containers/Pages/Type/Type";
import ConditionsManager from "./Containers/Pages/UserQuestions/ConditionsManager";
import FormResponses from "./Containers/Pages/UserQuestions/FormResponses";
import QuestionsManager from "./Containers/Pages/UserQuestions/QuestionsManager";
import QuestionsToFlags from "./Containers/Pages/UserQuestions/QuestionsToFlags/QuestionsToFlags";
import QuestionsToFlagsLocal from "./Containers/Pages/UserQuestions/QuestionsToFlags/QuestionsToFlagsLocal";
import UserQuestions from "./Containers/Pages/UserQuestions/UserQuestions";
import UserRoadmap from "./Containers/Pages/UserRoadmap/UserRoadmap";
import UserRoadmapBeta from "./Containers/Pages/UserRoadmap/UserRoadmapBeta";
import Ways from "./Containers/Pages/Ways/Ways";
import Root from "./Containers/Root/Root";
import * as actions from "./store/actions/action";
import SendPlainSms from "./Containers/Pages/SendPlainSms/SendPlainSms";
import SendPredefinedSms from "./Containers/Pages/SendPredefinedSms/SendPredefinedSms";
import SentSmsReport from "./Containers/Pages/SentSmsReport/SentSmsReport";
import PredefinedSms from "./Containers/Pages/PredefinedSms/PredefinedSms";
import SnapppayPayments from "./Containers/Pages/SnapppayPayments/SnapppayPayments";
import SnapppayCancel from "./Containers/Pages/SnapppayCancel/SnapppayCancel";
import OrderDiscount from "./Containers/Pages/OrderDiscount/OrderDiscount";
import Leads from "./Containers/Pages/Leads/Leads";
import LeadExports from "./Containers/Pages/LeadExports/LeadExports";
import LeadExportDetails from "./Containers/Pages/LeadExports/LeadExportDetails";
import LastLeads from "./Containers/Pages/MyLeads/MyLeads";
import CardToCards from "./Containers/Pages/CardToCards/CardToCards";
import MyLeads from "./Containers/Pages/MyLeads/MyLeads";
import RenewalLeads from "./Containers/Pages/RenewalLeads/RenewalLeads";
import PredefinedSmsEdit from "./Containers/Pages/PredefinedSmsEdit/PredefinedSmsEdit";
import PredefinedSmsCreate from "./Containers/Pages/PredefinedSmsCreate/PredefinedSmsCreate";
import SmsTemplates from "./Containers/Pages/SmsTemplates/SmsTemplates";
import SmsTemplateEdit from "./Containers/Pages/SmsTemplateEdit/SmsTemplateEdit";
import NotificationReceivers from "./Containers/Pages/NotificationReceivers/NotificationReceivers";
import NotificationReceiverEdit from "./Containers/Pages/NotificationReceiverEdit/NotificationReceiverEdit";
import SmsLines from "./Containers/Pages/SmsLines/SmsLines";
import SmsCampaigns from "./Containers/Pages/SmsCampaigns/SmsCampaigns";
import SmsCampaignEditor from "./Containers/Pages/SmsCampaignEditor/SmsCampaignEditor";
import SmsCampaignView from "./Containers/Pages/SmsCampaignView/SmsCampaignView";
import SiteSettings from "./Containers/Pages/SiteSettings/SiteSettings";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="" element={<Root />}>
      <Route
        path=""
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="" element={<Home />} />
        <Route path="/settings" element={
          <PermissionRoute requiredPermissions={["setting_list"]}>
            <SiteSettings />
          </PermissionRoute>
        } />
        <Route path="/roadmaps" element={<Roadmaps />} />
        <Route path="/permission_manager/:role?" element={<PermissionAccess />} />
        <Route path="/user-roadmap/:id" element={<UserRoadmap />} />
        <Route path="/user-roadmap-beta/:id" element={<UserRoadmapBeta />} />

        <Route path="/user-questions" element={<UserQuestions />}>
          {/* <Route path="questions" element={<QuestionsManager />} /> */}
          {/* <Route path="conditions" element={<ConditionsManager />} /> */}
          <Route
            path="questions-to-flags/:epollformid/:title"
            element={<QuestionsToFlags />}
          />
        </Route>

        {/* questions manager */}
        <Route path="/question" element={<UserQuestions />}>
          {/* create new question from */}
          <Route path="new" element={<QuestionsManager />} />
          {/* edit existing question from */}
          <Route path=":key" element={<QuestionsManager />} />
          {/* edit conditions of question from */}
          <Route path=":key/conditions" element={<ConditionsManager />} />
          {/* relation between flags and questions options  */}
          <Route
            path=":key/questions-to-flags"
            element={<QuestionsToFlagsLocal />}
          />
          <Route path=":key/responses" element={<FormResponses />} />
        </Route>

        <Route path="/type/:id" element={<Type />} />
        <Route path="/flags" element={<Flags />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/ways" element={<Ways />} />
        <Route path="/external-discount" element={<ExternalDiscount />} />
        <Route path="/order-discount" element={<OrderDiscount />} />
        <Route path="/roadmapTypes" element={<RoadmapTypes />} />
        <Route path="/reports" element={<Reports />}>
          <Route path="operators" element={<OperatorsReport />} />
          <Route path="users" element={<UsersReport />} />
          <Route path="questions" element={<QuestionsReport />} />
          <Route path="vote-report" element={<VoteReport />} />
          <Route
            path="consulting-requests"
            element={<ConsultingRequestsReport />}
          />
        </Route>
        <Route path="/permissions" element={<Permissions />}>
          <Route path="admins" element={<Admins />} />
          <Route path="roles" element={<Roles />} />
        </Route>
        <Route path="/product" element={<Product />}>
          <Route path="discount-code" element={<DiscountCode />} />
          <Route path="price" element={<Price />} />
        </Route>

        <Route path="/auto-note-manager" element={<AutoNoteManager />} />
        <Route path="/permissionDenied" element={<PermissionDenied />} />
        <Route path="/payment/skip" element={<PaymentSkip />} />
        <Route path="/copy-roadmap" element={<CopyRoadmap />} />
        <Route path="/switch-username" element={<SwitchUsername />} />
        <Route path="/send-plain-sms" element={<SendPlainSms />} />
        <Route path="/send-predefined-sms" element={<SendPredefinedSms />} />
        <Route path="/sent-sms-report" element={<SentSmsReport />} />
        <Route path="/predefined-sms" element={<PredefinedSms />} />
        <Route
          path="/predefined-sms/edit/:id"
          element={<PredefinedSmsEdit />}
        />
        <Route
          path="/predefined-sms/edit/:id"
          element={<PredefinedSmsEdit />}
        />
        <Route
          path="/predefined-sms/create"
          element={<PredefinedSmsCreate />}
        />
        <Route path="/sms-templates" element={<SmsTemplates />} />
        <Route path="/sms-lines" element={<SmsLines />} />
        <Route path="/sms-campaigns" element={
          <PermissionRoute requiredPermissions={smsCampaignPermissions.list}>
            <SmsCampaigns />
          </PermissionRoute>
        } />
        <Route path="/sms-campaigns/create" element={
          <PermissionRoute requiredPermissions={smsCampaignPermissions.create}>
            <SmsCampaignEditor />
          </PermissionRoute>
        } />
        <Route path="/sms-campaigns/:id/edit" element={
          <PermissionRoute requiredPermissions={smsCampaignPermissions.edit}>
            <SmsCampaignEditor />
          </PermissionRoute>
        } />
        <Route path="/sms-campaigns/:id" element={
          <PermissionRoute requiredPermissions={smsCampaignPermissions.view}>
            <SmsCampaignView />
          </PermissionRoute>
        } />
        <Route path="/sms-templates/edit/:id" element={<SmsTemplateEdit />} />
        <Route path="/notifications" element={<NotificationReceivers />} />
        <Route
          path="/notifications/edit/:id"
          element={<NotificationReceiverEdit />}
        />
        <Route path="/snapppay-payments" element={<SnapppayPayments />} />
        <Route path="/snapppay-cancel" element={<SnapppayCancel />} />
        <Route path="/leads" element={<Leads />} />
        <Route path="/lead-exports" element={<LeadExports />} />
        <Route path="/lead-exports/:id" element={<LeadExportDetails />} />
        <Route path="/myleads" element={<MyLeads />} />
        <Route path="/renewal-leads" element={<RenewalLeads />} />
        <Route path="/card-to-cards" element={<CardToCards />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="login" element={<Login />} />
    </Route>,
  ),
);
function App({ setToken, onGetUserData }) {
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setToken(token);
      onGetUserData(token);
    }
    moment.locale("fa");
  }, []);
  return <RouterProvider router={router} />;
}
const mapStateToProps = (state) => {
  return {
    token: state.token,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setToken: (token) => dispatch(actions.TokenSetter(token)),
    onGetUserData: (token) => dispatch(actions.StartGetUserData(token)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
